import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Mail, Phone, MapPin, Github, Linkedin } from 'lucide-react';

const Header = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = ['Profil', 'Expériences', 'Compétences', 'Projets', 'Stack'];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 w-full z-50 transition-all duration-300 font-mono ${
        scrolled ? 'bg-dark-surface/95 backdrop-blur-lg border-b border-violet-500/20' : 'bg-transparent'
      }`}
    >
      <nav className="container mx-auto px-4 py-4  section-spacing">
        <div className="flex items-center justify-between">
          {/* Logo / Nom - style terminal */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="text-xl font-bold"
          >
            <span className="text-gray-400">~/</span>
            <span className="gradient-text">richard</span>
            <span className="text-gray-400">$</span>
          </motion.div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            {menuItems.map((item, index) => (
              <motion.a
                key={item}
                href={`#${item.toLowerCase()}`}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.1 }}
                className="text-gray-300 hover:text-violet-400 transition-colors text-sm"
              >
                {item}
              </motion.a>
            ))}
          </div>

          {/* Contact Icons */}
          <div className="hidden md:flex items-center space-x-3">
            <motion.a
              whileHover={{ scale: 1.2, rotate: 5 }}
              href={`mailto:${data.email}`}
              className="text-gray-300 hover:text-violet-400"
            >
              <Mail size={18} />
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.2, rotate: 5 }}
              href={`tel:${data.phone}`}
              className="text-gray-300 hover:text-violet-400"
            >
              <Phone size={18} />
            </motion.a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-300 hover:text-violet-400"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden mt-4 bg-dark-surface rounded-lg p-4 border border-violet-500/20"
          >
            {menuItems.map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                onClick={() => setIsOpen(false)}
                className="block py-2 text-gray-300 hover:text-violet-400 transition-colors"
              >
                {item}
              </a>
            ))}
            <div className="flex gap-3 mt-4 pt-4 border-t border-dark-border">
              <a href={`mailto:${data.email}`} className="text-gray-400 hover:text-violet-400">
                <Mail size={18} />
              </a>
              <a href={`tel:${data.phone}`} className="text-gray-400 hover:text-violet-400">
                <Phone size={18} />
              </a>
            </div>
          </motion.div>
        )}
      </nav>
    </motion.header>
  );
};

export default Header;